import React, { useState } from "react";
import * as Icons from "heroicons-react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import {
  useAccountheadsQuery,
  useDeleteAccountHeadMutation
} from "../../services/accountHeadApi";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import { useSelector } from "react-redux";

const AccountHeads = () => {
  const auth = signInUser();
  const lang = useSelector((state) => state.languageReducer);

  const { aamarId } = auth || {};
  let i = 1;
  const [searchTerm, setSearchTerm] = useState("");
  const { data, error, isLoading, isFetching, isSuccess } =
    useAccountheadsQuery({ aamarId }, { skip: !aamarId });
  const [deleteAccountsHead] = useDeleteAccountHeadMutation();

  const handleDataLimit = () => {};
  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const deleteHandler = async (e) => {
    const result = await Swal.fire({
      title: "Are you Sure?",
      text: "Delete this Account Head?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      if (
        e === "643e3ff315c557ac29f9d7e7" ||
        e === "643e3fd515c557ac29f9d7e2"
      ) {
        notify("Can Not delete Default Account Head", "error");
      } else {
        await deleteAccountsHead(e)
          .then((res) => {
            notify("Account Head is Deleted", "success");
          })
          .catch((err) => {
            console.log(err);
            notify("Failed to delete Account Head", "error");
          });
      }
    } else {
      notify("Account Head Delete Canceled", "error");
    }
  };

  const filteredData = data?.filter((acHead) => {
    if (!searchTerm) return true;
    return (
      acHead?.name?.toLowerCase().includes(searchTerm) ||
      acHead?.code?.toLowerCase().includes(searchTerm) ||
      acHead?.maId?.name?.toLowerCase().includes(searchTerm)
    );
  });

  return (
    <div>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <div className="row">
              <div className="col-md-12">
                <Header title={lang?.allAccountsHead || "All Accounts Head"}></Header>
              </div>
              <div className="col-md-6 mt-2 mb-2">
                <form>
                  <div className="input-group mb-3">
                    <select
                      className="form-select rounded"
                      onClick={(e) => handleDataLimit(e)}
                    >
                      <option value="100">100</option>
                      <option value="150">150</option>
                      <option value="200">200</option>
                      <option value="250">250</option>
                    </select>
                    <input
                      className="form-control rounded ms-2"
                      type="text"
                      onKeyUp={(e) => handleSearch(e)}
                    />
                    {/* <input type="text" className="form-control" aria-label="Text input with dropdown button"> */}
                  </div>
                </form>
              </div>
              {/* <div className="col-md-9  mt-2 mb-2">Filters</div> */}
              <div className="col-md-6  mt-2 mb-2">
                <Link to="/addAccountHead" className="btn btn-dark float-end">
                  <Icons.Plus className="icon-edit" size={20}></Icons.Plus>
                  {lang?.addAccountHead || "Add Account Head"}
                </Link>
              </div>
            </div>

            <div
              className="table-responsive"
              style={{
                overflowY: "auto",
                maxHeight: window.innerWidth <= 768 ? "400px" : ""
              }}
            >
              <table className="table table-striped ">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Code</th>
                    <th scope="col">Sub AccountHead</th>
                    <th scope="col">AccountHead</th>
                    {/* <th scope="col">Group</th> */}
                    <th scope="col">AccountHead Code</th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions </th>
                  </tr>
                </thead>
                <tbody>
                  {/* {isLoading && <h2>...Loading</h2>}
                {isFetching && <h2>...isFetching</h2>}
                {error && <h2>Something went wrong</h2>} */}
                  {filteredData?.length > 0 ? (
                    filteredData?.map((acHead) => (
                      <tr key={acHead?._id}>
                        <th scope="row">{i++}</th>
                        <td>{acHead?.code}</td>
                        <td>{acHead?.name}</td>
                        <td>
                          {acHead?.maId
                            ? acHead?.maId?.name
                            : "Master Account Head"}
                        </td>
                        <td>{acHead?.maId ? acHead?.maId?.code : ""}</td>
                        <td>{acHead?.status}</td>
                        <td>
                          <Link to={`/accountheads/update/${acHead._id}`}>
                            <Icons.PencilAltOutline
                              className="icon-edit"
                              size={20}
                            ></Icons.PencilAltOutline>
                          </Link>
                          <Icons.TrashOutline
                            className="icon-trash"
                            size={20}
                            style={{ cursor: "pointer" }}
                            onClick={() => deleteHandler(acHead._id)}
                          ></Icons.TrashOutline>
                        </td>
                      </tr>
                    ))
                  ) : (
                    // <tr>
                    //   <td colSpan={6}>
                    //     {isLoading && <Skeleton count={100} />}
                    //     {/* {isFetching && <h2>...isFetching</h2>}
                    //     {error && <h2>Something went wrong</h2>} */}
                    //   </td>
                    // </tr>
                    <tr colSpan={9}>No AccountHead Found</tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountHeads;
